import React, { useState } from 'react'
import style from './copy.module.scss'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import PropTypes from 'prop-types'
import { VegaIcon } from '../icon/Icon'

const VegaCopy = ({ value }) => {
	const CopyLabel = () => (
		<CopyToClipboard text={value} onCopy={onCopy}>
			<VegaIcon name="copy" size={20} className={style.copy} />
		</CopyToClipboard>
	)

	const CopiedLabel = () => <VegaIcon name="check" size={20} className={style.copied} />

	const onCopy = () => {
		setCopyRender(CopiedLabel)
		setTimeout(() => setCopyRender(CopyLabel), 3000)
	}

	const [CopyRender, setCopyRender] = useState(CopyLabel)

	return CopyRender
}

VegaCopy.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Value to copy */
	value: PropTypes.string
}

export { VegaCopy }
